import { render, staticRenderFns } from "./safHeaManagePolicyDetail.vue?vue&type=template&id=57eff783"
import script from "./safHeaManagePolicyDetail.vue?vue&type=script&lang=js"
export * from "./safHeaManagePolicyDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('57eff783')) {
      api.createRecord('57eff783', component.options)
    } else {
      api.reload('57eff783', component.options)
    }
    module.hot.accept("./safHeaManagePolicyDetail.vue?vue&type=template&id=57eff783", function () {
      api.rerender('57eff783', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sai/shm/safHeaManagePolicyDetail.vue"
export default component.exports